import { isFramed } from './isFramed'

interface IframeResizerChildOptions {
  license: string
  [option: string]: unknown
}

declare global {
  interface Window {
    iframeResizer?: IframeResizerChildOptions
  }
}

/**
 * Registers the iframe-resizer child so the framing page can size this iframe
 * to its content. No-op when not framed; never rejects.
 * https://iframe-resizer.com/setup/child/
 */
export const registerIframeResizerChild = async (): Promise<boolean> => {
  if (!isFramed()) return false

  try {
    // Importing the package is what starts the child, and it reads its options
    // off the global, so the license goes there first. The dynamic import keeps
    // the chunk off unframed loads.
    window.iframeResizer = { ...window.iframeResizer, license: iframeResizerLicense }
    await import('@iframe-resizer/child')
    return true
  } catch (error) {
    // A frame whose child half cannot load stays at the fixed height the framing page's
    // CSS gives the post-funnel iframe, and scrollable -- the parent attaches with
    // scrolling 'omit' so its overflow is not disabled.
    console.error('iframe-resizer child failed to load; the framing page cannot size this iframe', error)
    return false
  }
}
